var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "font-size": "20px",
        "font-weight": "bold",
        "text-align": "center",
        "margin-top": "100px",
      },
    },
    [_vm._v(" 欢迎使用沃赢后台管理系统 ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }